"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MeldType_1 = require("../../meld/MeldType");
/**
 * Determine if the WinningHand is a SmallWinds (Chinese: 小四喜).
 * @param inputWinningHand WinningHand to be evaluated.
 * @returns true if the inputWinningHand is a SmallWinds (Chinese: 小四喜).
 */
function isSmallWinds(inputWinningHand) {
    // red dragon or green dragon or white dragon
    let pongsOrKongsOfWinds = 0;
    let hasEyesOfWinds = false;
    const melds = inputWinningHand.getMelds();
    for (const meld of melds) {
        const isWind = meld.getSuitType() === 'honor' && meld.getTiles()[0].getValue() <= 4;
        if (meld.getMeldType() === MeldType_1.MeldType.EYES) {
            if (isWind)
                hasEyesOfWinds = true;
            continue;
        }
        if (meld.getMeldType() === MeldType_1.MeldType.PONG || meld.getMeldType() === MeldType_1.MeldType.KONG) {
            if (isWind)
                pongsOrKongsOfWinds++;
        }
    }
    return pongsOrKongsOfWinds === 3 && hasEyesOfWinds;
}
exports.default = isSmallWinds;
